export default __webpack_public_path__ + "static/media/controlBack24.1a184cea.svg";